import { render, staticRenderFns } from "./ContainerOrderDialog.vue?vue&type=template&id=0a24fe0d"
import script from "./ContainerOrderDialog.vue?vue&type=script&lang=js"
export * from "./ContainerOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports